import { styled } from '@goodfynd/theme';

import TrendGraph from '../../../components/TrendGraph';

export const StyledChart = styled('section', {
  alignItems: 'center',
  display: 'flex',
  marginTop: 16,
  minHeight: 165,
  minWidth: '100%',
  position: 'relative',
  '> section': {
    bottom: 10,
    left: 0,
    position: 'absolute',
    width: '100%',
    zIndex: -1,
  },
});

export const StyledTrendGraph = styled(TrendGraph, {
  borderBottom: '1px solid $Neutral05',
  width: '100%',
});
